var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-field',{ref:"zoneSelector",staticClass:"timezones",attrs:{"value":_vm.value,"items":_vm.timezones,"empty-option":false,"disabled":_vm.disabled},on:{"selected":_vm.valueChanged,"focus":_vm.onFocus,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }